import Enum from '/@/modules/core/app/helpers/Enum';
import Lang from '/@/modules/core/app/services/Lang';

export class Gender extends Enum {
  key!: string;
  value!: string;

  static MALE: Gender = {
    key: 'male',
    get value(): string {
      return Lang.t('contact.male');
    }
  };

  static FEMALE: Gender = {
    key: 'female',
    get value(): string {
      return Lang.t('contact.female');
    }
  };

  static NONBINARY: Gender = {
    key: 'nonbinary',
    get value(): string {
      return Lang.t('asset.other');
    }
  };
}
